module.exports = __webpack_public_path__ + "static/img/icon-success.9d28217.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/icon-success.png
// module id = 6wUG
// module chunks = 54